import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Modals from "../../../components/modal";
import { useExport } from "./hooks";
import ExportForm from "./form/export-form";
import { useUser } from "./../../../common-hooks/user";

const ExportComponent = (props) => {
  const {
    toggleModal,
    isOpenModal,
    isLoading,
    downloadCourseReport,
    dateError,
    setDateError,
  } = useExport(props);

  const { isAdmin, isModerator, isCSSpecialist } = useUser();

  if (!isAdmin && !isModerator && !isCSSpecialist) {
    return null;
  }

  return (
    <div>
      <Tooltip title="Download Courses" placement="bottom">
        <i
          className="fa fa-file-excel-o fa-2x icon-btn-action"
          onClick={toggleModal}
        ></i>
      </Tooltip>
      {isOpenModal ? (
        <Modals
          isOpenModal
          setIsOpenModal={toggleModal}
          message={
            <ExportForm
              isLoading={isLoading}
              downloadCourseReport={downloadCourseReport}
              dateError={dateError}
              setDateError={setDateError}
            />
          }
          title="Export Courses"
        />
      ) : null}
    </div>
  );
};

export default ExportComponent;
